
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  setup() {
    const route = useRoute()
    const theme = (route.query.theme as string) || 'light'
    function gotobrowser() {
      let url: any = route.query.url
      url = decodeURIComponent(url) + '&zspecifyfield=pdf'
      window.open(`gw://openurl?param=${url}`)
    }

    return {
      gotobrowser,
      theme
    }
  }
})
